import amazonPay from 'images/stripe/amazon-pay.svg';
import amex from 'images/stripe/amex.svg';
// Undecided if this makes sense, it's a lot of icons when words would suffice
// import apple from 'images/stripe/apple.svg';
import diners from 'images/stripe/diners.svg';
import discover from 'images/stripe/discover.svg';
import google from 'images/stripe/google.svg';
import jcb from 'images/stripe/jcb.svg';
import mastercard from 'images/stripe/mastercard.svg';
import unionpay from 'images/stripe/unionpay.svg';
import visa from 'images/stripe/visa.svg';
import Img from 'next/image';

const CardImage = ({ brand }) => {
  // https://stripe.com/docs/api/payment_methods/object#payment_method_object-card-brand
  switch (brand) {
    case 'amazon_pay':
      return <Img src={amazonPay} alt={'Amazon Pay'} height="48" width="60" />;
    case 'amex':
      return <Img src={amex} alt={'Amex'} height="48" width="60" />;
    case 'diners':
      return <Img src={diners} alt={'Diners Club'} height="48" width="60" />;
    case 'discover':
      return <Img src={discover} alt={'Discover'} height="48" width="60" />;
    case 'google_pay':
      return <Img src={google} alt={'Google Pay'} height="48" width="60" />;
    case 'jcb':
      return <Img src={jcb} alt={'JCB'} height="48" width="60" />;
    case 'mastercard':
      return <Img src={mastercard} alt={'Mastercard'} height="48" width="60" />;
    case 'unionpay':
      return <Img src={unionpay} alt={'UnionPay'} height="48" width="60" />;
    case 'visa':
      return <Img src={visa} alt={'Visa'} height="48" width="60" />;
    default:
      // TODO: Generic card image
      return null;
  }
};

// Check if this is a payment method that has card-like details
const hasCardDetails = (brand) => {
  const nonCardBrands = ['amazon_pay'];
  return !nonCardBrands.includes(brand);
};

const CardSylization = ({ brand, last4, expMonth, expYear, label }) => (
  <div className="flex grow flex-wrap gap-4 font-mono">
    <CardImage brand={brand} />
    {hasCardDetails(brand) ? (
      <div className="flex flex-col text-sm whitespace-nowrap">
        <span>•••• •••• •••• {last4}</span>
        <span>
          Expiry {expMonth}/{expYear}
        </span>
      </div>
    ) : (
      <div className="flex items-center">
        <span className="text-sm">
          {label || `Your ${brand.replace('_', ' ')} account is connected.`}
        </span>
      </div>
    )}
  </div>
);

export default CardSylization;
